export { default } from "./SaveSearch.page";
